import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section about">
            <img src="/logo_dietalase.png" alt="Dietalase Logo" className="footer-logo" />
            <p><strong>Whatsapp:</strong> +62 851-7444-9326</p>
            <p><strong>Email:</strong> dietalase@tibor.co.id</p>
            <p><strong>Address:</strong> Jl. Mayjend Sutoyo S No 20 Lantai 2 Kel. Teluk Dalam Kota Banjarmasin, Kalimantan Selatan</p>
          </div>
          <div className="footer-section links">
            <h4>Kategori Populer</h4>
            <ul>
              <li><a href="#">Elektronik</a></li>
              <li><a href="#">Furniture</a></li>
              <li><a href="#">Alat Tulis Kantor (ATK)</a></li>
              <li><a href="#">Perkakas</a></li>
              <li><a href="#">Akomodasi</a></li>
            </ul>
          </div>
          <div className="footer-section links">
            <h4>Layanan Pelanggan</h4>
            <ul>
              <li><a href="#">Tentang Kami</a></li>
              <li><a href="#">Syarat & Ketentuan</a></li>
              <li><a href="#">FAQ</a></li>
              <li><a href="#">Kebijakan Privasi</a></li>
              <li><a href="#">Cancellation & Return Policy</a></li>
            </ul>
          </div>
          <div className="footer-section partners">
            <h4>Pembayaran</h4>
            <div className="partner-logos">
              {/* Add payment logos here */}
            </div>
            <h4>Pengiriman</h4>
            <div className="partner-logos">
              {/* Add shipping logos here */}
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 DIETALASE. All rights reserved. Created with ❤️</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
